(function () {
  'use strict';

 const FREE_GIFT_VARIANT_ID = 49082678247641;
  const REQUIRED_TOMATOES = 5;
  const GIFT_PROPERTY = '_automatic_tomato_gift';
  const GIFT_PROPERTY_VALUE = 'true';

  let updatingGift = false;

  async function getCart() {
    const response = await fetch(
      window.Shopify.routes.root + 'cart.js',
      {
        headers: {
          'Accept': 'application/json'
        }
      }
    );

  if (!response.ok) {
  const errorText = await response.text();
  console.error('SHOPIFY GIFT ERROR:', errorText);
  throw new Error('Could not add free gift: ' + errorText);
}

    return response.json();
  }

  function countTomatoes(cart) {
    let tomatoCount = 0;

    cart.items.forEach(function (item) {
      /*
       * The tomato variant IDs are supplied by Liquid
       * in theme.liquid.
       */
      if (
        window.GARDENWORLD_TOMATO_VARIANT_IDS &&
        window.GARDENWORLD_TOMATO_VARIANT_IDS.includes(Number(item.variant_id))
      ) {
        tomatoCount += item.quantity;
      }
    });

    return tomatoCount;
  }

  function findAutomaticGift(cart) {
    return cart.items.find(function (item) {
      return (
        Number(item.variant_id) === FREE_GIFT_VARIANT_ID &&
        item.properties &&
        item.properties[GIFT_PROPERTY] === GIFT_PROPERTY_VALUE
      );
    });
  }

  async function addFreeGift() {
    const response = await fetch(
      window.Shopify.routes.root + 'cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: FREE_GIFT_VARIANT_ID,
              quantity: 1,
              properties: {
                [GIFT_PROPERTY]: GIFT_PROPERTY_VALUE
              }
            }
          ]
        })
      }
    );

    if (!response.ok) {
      throw new Error('Could not add free gift.');
    }

    return response.json();
  }

  async function removeFreeGift(lineKey) {
    const response = await fetch(
      window.Shopify.routes.root + 'cart/change.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      }
    );

    if (!response.ok) {
      throw new Error('Could not remove free gift.');
    }

    return response.json();
  }

  async function updateFreeGift() {
    if (updatingGift) return;

    updatingGift = true;

    try {
      const cart = await getCart();

      const tomatoCount = countTomatoes(cart);
      const automaticGift = findAutomaticGift(cart);

      /*
       * Five or more tomatoes = exactly ONE free fertiliser.
       */
      if (tomatoCount >= REQUIRED_TOMATOES) {
        if (!automaticGift) {
          await addFreeGift();
        }
      }

      /*
       * Fewer than five tomatoes = remove ONLY our
       * automatically-added fertiliser.
       *
       * A fertiliser manually added by the customer
       * is left completely alone.
       */
      else if (automaticGift) {
        await removeFreeGift(automaticGift.key);
      }

    } catch (error) {
      console.error(
        'Gardenworld tomato free gift:',
        error
      );
    } finally {
      updatingGift = false;
    }
  }

  /*
   * Run when the page first loads.
   */
  document.addEventListener('DOMContentLoaded', function () {
    updateFreeGift();
  });

  /*
   * Catch common Shopify cart events.
   */
  document.addEventListener('cart:updated', function () {
    updateFreeGift();
  });

  document.addEventListener('cart:refresh', function () {
    updateFreeGift();
  });

  /*
   * Also check whenever the cart changes through
   * a normal add-to-cart form.
   */
  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (
      form &&
      form.action &&
      form.action.includes('/cart/add')
    ) {
      setTimeout(updateFreeGift, 800);
    }
  });

})();